import { Injectable, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';

// Import Setting Service and User, Credential Model
import { Admin, AdminCredential } from '../';
import { ApiService, SettingService } from '../../core/services';
import { AdminPassword } from '../models/AdminPassword';

@Injectable()
export class SessionService {
    private sessionUrl = '/session';
    private apiUrl = '';

    constructor (
        private settingService: SettingService,
        private apiService: ApiService
    ) {
        this.apiUrl = this.settingService.getSetting('api_service_domain');
    }

    getSession (): Observable<Admin> {
        const requestUrl = this.apiUrl + this.sessionUrl;
        
        // Call Get Method from Api Service
        return this.apiService.get<Admin>(requestUrl);
    }

    postAdminSession (adminCredential: AdminCredential): Observable<Admin> {
        const requestUrl = '/ldap?' + 'username=' + adminCredential.username + '&password=' + adminCredential.password;

        const body = JSON.stringify({ 
                        'role': adminCredential.role,
                        'username': adminCredential.username,
                        'password': adminCredential.password
                     });
        
        // Call Get Method from Api Service
        return this.apiService.post<Admin>(requestUrl, body);
    }

    deleteAdminSession (): Observable<any> {
        // const requestUrl = 'http://auth.eca.nascorp.vn/logout';
        const requestUrl = this.apiUrl + this.sessionUrl;
        return this.apiService.delete(requestUrl);
    }

    changeAdminPassword(adminPassword: AdminPassword): Observable<Admin> {
        const requestUrl = this.apiUrl + '/ldap-change-password';

        const body = JSON.stringify({ 
                        'username': adminPassword.username,
                        'oldPassword': adminPassword.password.old,
                        'newPassword': adminPassword.password.new,
                     });
        
        // Call Get Method from Api Service
        return this.apiService.post<Admin>(requestUrl, body);
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/admin/services/SessionService.ts